var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDockingSuccessful(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.795,
    height: 54.85,
    viewBox: "0 0 34.795 54.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1737",
    "data-name": "Group 1737",
    transform: "translate(-796.516 -511.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checkmark-circle",
    d: "M58,48A10,10,0,1,0,68,58,10.009,10.009,0,0,0,58,48Zm5.2,6.647-6.46,7.691a.769.769,0,0,1-.577.274h-.013a.769.769,0,0,1-.572-.255l-2.769-3.076a.769.769,0,1,1,1.143-1.029l2.177,2.419,5.893-7.014a.769.769,0,1,1,1.178.989Z",
    transform: "translate(748.516 483.426)",
    fill: "#56ae4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NavigatingIcon",
    transform: "translate(754.467 508.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M156.131,158.379v20.759H135.089l1.087-1.316h17.985l.106-14.041h-3.625Z",
    transform: "translate(-79.287 -121.29)",
    fill: "#56ae4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1736",
    "data-name": "Group 1736",
    transform: "translate(55.534 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1722",
    "data-name": "Group 1722",
    transform: "translate(7.883 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M66.118,43.037",
    transform: "translate(-62.195 -34.253)",
    fill: "#56ae4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M68.391,17.677a1.325,1.325,0,0,1-.649,1.279v6.059c0,1.009-1.1,1.459-1.726,1.459H64.739c-.622,0-.726-.451-.726-1.46V5.28c0-1.009.1-2.28.726-2.28h1.277c.623,0,1.726,1.271,1.726,2.28v5.352",
    transform: "translate(-64.013 -3)",
    fill: "#56ae4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M74.059,222.413a3.769,3.769,0,1,1-3.769-3.769A3.768,3.768,0,0,1,74.059,222.413Zm-1.7,0a2.066,2.066,0,1,0-2.067,2.067A2.066,2.066,0,0,0,72.357,222.413Z",
    transform: "translate(-62.342 -171.332)",
    fill: "#56ae4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M47.613,46.865c-.573,2.336.647,11.9.515,19.285-.161,9.036,1.07,13.582,1.809,15.477a10.98,10.98,0,0,1,1.2,2.5,26.731,26.731,0,0,1,1.132,3.5c.306,1.2.489,2-.849,2H45.39a4.2,4.2,0,0,0,.547-1.969A4.386,4.386,0,0,0,42.479,83.3a4.437,4.437,0,0,0-5.452,4.3,4.084,4.084,0,0,0,.547,2.03H35.688a2.019,2.019,0,0,1-2.136-2.31l.221-1.678c.126-1.012.728-3.823,1.469-4.744a1.954,1.954,0,0,1,1.582-.72L47.058,82c-.876-2.544-1.9-7.377-1.752-15.9.254-14.213-.257-19.95,0-20.122",
    transform: "translate(-33.534 -36.547)",
    fill: "#56ae4d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockingSuccessful);
export default __webpack_public_path__ + "static/media/docking-successful.a27afffb5c5fbc7dd49ea30787627b24.svg";
export { ForwardRef as ReactComponent };